// Libraries
var React = require('react');

class DefenderLineupStats extends React.Component {
	render() {
		return (
			<div>
				<div className="LineupPlayer__stats">
					{!isNaN(this.props.MinutesPlayed) && this.props.MinutesPlayed > 0 &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Minutes Played</p>
								<p className="LineupPlayer__stat--value">{this.props.MinutesPlayed}</p>
							</div>
					}

					{!isNaN(this.props.GoalsScored) &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Goals Scored</p>
								<p className="LineupPlayer__stat--value">{this.props.GoalsScored}</p>
							</div>
					}

					{!isNaN(this.props.Assists) &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Assists</p>
								<p className="LineupPlayer__stat--value">{this.props.Assists}</p>
							</div>
					}

					{!isNaN(this.props.Clearances) &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Clearances</p>
								<p className="LineupPlayer__stat--value">{this.props.Clearances}</p>
							</div>
					}

					{!isNaN(this.props.Interceptions) &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Interceptions</p>
								<p className="LineupPlayer__stat--value">{this.props.Interceptions}</p>
							</div>
					}

					{!isNaN(this.props.TacklesTotal) &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Total Tackles</p>
								<p className="LineupPlayer__stat--value">{this.props.TacklesTotal}</p>
							</div>
					}

					{!isNaN(this.props.YellowCards) && !isNaN(this.props.RedCards) &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Cards</p>
								<p className="LineupPlayer__stat--value"><span className="yellowcard" aria-label="Number of yellow cards">{this.props.YellowCards}</span> <span className="redcard" aria-label="Number of red cards">{this.props.RedCards}</span></p>
							</div>
					}
				</div>
			</div>
		)
	}
}

module.exports = DefenderLineupStats;



// WEBPACK FOOTER //
// ./src/components/MDC/Lineup/DefenderLineupStats.js